import React, { useState, useEffect, useRef } from 'react';
import { useIsVisible } from 'react-is-visible';
import CastButton from '../../chrome-cast/cast-button';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { genKeyRan, Sleep, ConfirmModel } from '../../../javascript/utils/utils';
// import SportLoader from '../../../javascript/sport/sport-loader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SPORT_BASE } from '../../../javascript/services/globalVars';
import { Handle_Game_Change } from '../../../javascript/utils/game-utils';
import { load_SportLoader_from_db } from '../../../javascript/services/globalVars';
import BtnSoundCheck from '../../static-btns/btn-sound-check/btn-sound-check';
import style from './score-setup-form-style.module.scss';


function ScoreSetupForm(Props) {
   const type = Props.type;
   const formClass = type === 'mod' ? style.modWrap : '';
   const btnText = type === 'mod' ? 'Modify Match' : 'Start Match';
   const wrapper = useRef();
   const formRef = useRef(null);
   const [scoreSettings, setScoreSettings] = useState('');
   const [updateKey, setUpdateKey] = useState(0);
   const isVisible = useIsVisible(wrapper);

   var APPLYING_RESET = false;


   const form_values = (elements) => {
      let valueObj = {};
      const sportSettings = SPORT_BASE.sport_object.settings;
      SPORT_BASE.sport_object.map(sportSettings, (item) => {
         const elementName = item.value.name;
         if (typeof elements[elementName] !== 'undefined') {
            const val = elements[elementName].value;
            valueObj[elementName] = val;
            // >>> For Sub Values
            if (typeof item.value.sub_value !== 'undefined') {
               const subName = item.value.sub_value.name;
               const subValue = elements[subName].value;
               valueObj[subName] = subValue;
            }
         }
      });
      return valueObj;
   }

   const handleSubmit = async (event) => {
      event.preventDefault();

      const matchSettings = form_values(event.target.elements);
      const validation_result = await validate_form(matchSettings);

      if (validation_result.length > 0) {
         for (let a = 0; a < validation_result.length; a++) {
            const message = validation_result[a].message;
            // console.log('>>> message <<<', message);
            await ConfirmModel({
               title: 'Validation Error',
               text: message,
               confirmButtonText: 'OK',
               showCancelButton: false,
            });
         }
         return; 
      }
      
      // If validation passes, continue with the form submission
      Handle_Game_Change(matchSettings, type);
   }

   const validate_form = async (matchSettings) => {
      try {
         const NEW_SPORT_BASE = await load_SportLoader_from_db(true);
         const setup_validation_result = NEW_SPORT_BASE.setupValidate(matchSettings);
         if (setup_validation_result.length > 0) {
            for (const key in formRef.current.elements) {
               if (Object.prototype.hasOwnProperty.call(formRef.current.elements, key)) {
                  if (isNaN(parseInt(key))) {
                     const element = formRef.current.elements[key];
                     if (setup_validation_result.findIndex(item => item.setting === key) !== -1) {
                        element.classList.add(style.validationError);
                     } else {
                        element.className = '';
                     }
                  }
               }
            }
         } else {
            // Remove all validation errors
            for (const key in formRef.current.elements) {
               if (Object.prototype.hasOwnProperty.call(formRef.current.elements, key)) {
                  if (isNaN(parseInt(key))) {
                     const element = formRef.current.elements[key];
                     element.className = '';
                  }
               }
            }
         }
         
         return setup_validation_result;
      } catch (error) {
         console.error('SportLoader - validate_form: ', error);
         return [];
      }
   }


   const handleChange = (event) => {
      const changedElement = event.nativeEvent.srcElement.name;
      const matchSettings = form_values(event.target.form.elements);
      validate_form(matchSettings);
      update_scoreSettings(matchSettings, changedElement);
   }

   const update_scoreSettings = async (fromValues = null, changedElement = null) => {
      if (APPLYING_RESET === false) {
         let setupElement;
         if (type === 'mod') {
            setupElement = SPORT_BASE.setupBuild(fromValues, changedElement, type);
         } else if (type === 'new') {
            const NEW_SPORT_BASE = await load_SportLoader_from_db(true);
            setupElement = NEW_SPORT_BASE.setupBuild(fromValues, changedElement, type);
         }

         // console.log('Update Settings Elements - Type: '+type+' - Changed Element: '+changedElement+' - From Values: ',fromValues);
         setScoreSettings(setupElement);
      }
   }

   const reset_to_default = async () => {
      try {
         const NEW_SPORT_BASE = await load_SportLoader_from_db(true);
         const setupElement = NEW_SPORT_BASE.setupBuild(null, null, type);
         console.debug('[DEBUG] - ScoreSetupForm - reset_to_default: ', setupElement);
         // console.log('[DEBUG] - ScoreSetupForm - reset_to_default: ', setupElement);
         APPLYING_RESET = true;
         await Sleep(50);
         setScoreSettings(setupElement);
         await Sleep(500);
         APPLYING_RESET = false;
      } catch (error) {
         console.error('[DEBUG] - ScoreSetupForm - reset_to_default: ', error);
         APPLYING_RESET = false;
      }
   }

   useEffect(() => {
      if (isVisible === true) {
         let settings = null;
         if (type === 'mod') {
            let tmpSettings = {};
            for (let a = 0; a < SPORT_BASE.sport_object.scoring.settings.length; a++) {
               const name = SPORT_BASE.sport_object.scoring.settings[a].name;
               const value = SPORT_BASE.sport_object.scoring.settings[a].value;
               tmpSettings[name] = value;
            }
            settings = tmpSettings;
         }

         update_scoreSettings(settings, null);
         setUpdateKey(genKeyRan('setupWrap'));
      }
   }, [isVisible, type, Props.refresh]);

   useEffect(() => {
      if (Props.reset_default === true) {
         reset_to_default();
      }
   }, [Props.reset_default]);


   return (
      <div className={style.formWrap} ref={wrapper}>
         <form onChange={(e) => { handleChange(e) }} onSubmit={handleSubmit} key={updateKey} ref={formRef}>
            {scoreSettings}
            <div className={style.btnBar}>
               <BtnSoundCheck/>
               <div className={style.largeBtn} >
                  <button className={`${style.commitBtn} ${formClass}`} type="submit"> <FontAwesomeIcon icon={faPlay} /> {btnText} </button>
               </div>
               <div className={style.smallBtn} >
                  &nbsp;
                  <CastButton></CastButton>
               </div>

            </div>
         </form>
      </div>
   );
}

export default ScoreSetupForm;